import type {
  CheckoutSettings,
  CheckoutSettingsPatch,
} from "schemas/checkoutSettings";
import type { RequestFn } from "./request";

export function createCheckoutSettingsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    get: ({ projectId }: { projectId: string }) => {
      return request<{ settings: CheckoutSettings }>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/checkout-settings`,
      });
    },
    update: ({
      projectId,
      patch,
    }: {
      projectId: string;
      patch: CheckoutSettingsPatch;
    }) => {
      return request<{ settings: CheckoutSettings }>({
        method: "PUT",
        path: `/api/v1/projects/${projectId}/checkout-settings`,
        body: patch,
      });
    },
  };
}
